const initialState = {
    //list customer
    loadingOrganisationList: false,
    OrganisationListError: "",
    OrganisationList: [],

    //view customer
    loadingOrganisationDetail: false,
    OrganisationDetailError: "",
    OrganisationDetail: [],

    //list employee
    loadingEmployeeList: false,
    EmployeeListError: "",
    EmployeeList: [],

    //list iata airline
    loadingIATAAirlineList: false,
    IATAAirlineListError: "",
    IATAAirlineList: [],

    //list organisation iata 
    loadingOrganisationIATAList: false,
    OrganisationIATAListError: "",
    OrganisationIATAList: [],

    //detail organisation iata 
    loadingOrganisationIATADetail: false,
    OrganisationIATADetailError: "",
    OrganisationIATADetail: [],

    //list organisation reg 
    loadingOrganisationREGList: false,
    OrganisationREGListError: "",
    OrganisationREGList: [],

    //detail organisation reg 
    loadingOrganisationREGDetail: false,
    OrganisationREGDetailError: "",
    OrganisationREGDetail: [],

    //agent list
    loadingOrganisationAgentList: false,
    OrganisationAgentListError: "",
    OrganisationAgentList: [],


    //organistaion all final Quotation list
    loadingCompanyFinalQuotationList: true,
    CompanyFinalQuotationList: [],
    CompanyFinalQuotationCompanyDetails: {},
    CompanyFinalQuotationListError: '',

}

const OrganisationListReducer = (state = initialState, action) => {
    switch (action.type) {

        //list customer//
        case 'FIND_ORGANISATION_LIST_REQUEST':
            return {
                ...state,
                loadingOrganisationList: true,
                OrganisationList: "",
                OrganisationListError: '',
            };
        case 'FIND_ORGANISATION_LIST_SUCCESS':
            return {
                ...state,
                loadingOrganisationList: false,
                OrganisationList: action.payload,
            };
        case 'FIND_ORGANISATION_LIST_FAILURE':
            return {
                ...state,
                loadingOrganisationList: false,
                OrganisationListError: action.payload,
            };
        //list customer//

        //view customer//
        case 'FIND_ORGANISATION_DETAIL_REQUEST':
            return {
                ...state,
                loadingOrganisationDetail: true,
                OrganisationDetail: "",
                OrganisationDetailError: '',
            };
        case 'FIND_ORGANISATION_DETAIL_SUCCESS':
            return {
                ...state,
                loadingOrganisationDetail: false,
                OrganisationDetail: action.payload,
            };
        case 'FIND_ORGANISATION_DETAIL_FAILURE':
            return {
                ...state,
                loadingOrganisationDetail: false,
                OrganisationDetailError: action.payload,
            };
        //view customer//

        //list employee//
        case 'FIND_EMPLOYEE_LIST_REQUEST':
            return {
                ...state,
                loadingEmployeeList: true,
                EmployeeList: "",
                EmployeeListError: '',
            };
        case 'FIND_EMPLOYEE_LIST_SUCCESS':
            return {
                ...state,
                loadingEmployeeList: false,
                EmployeeList: action.payload,
            };
        case 'FIND_EMPLOYEE_LIST_FAILURE':
            return {
                ...state,
                loadingEmployeeList: false,
                EmployeeListError: action.payload,
            };
        //list employee//


        //list iata airline//
        case 'FIND_IATA_AIRLINE_REQUEST':
            return {
                ...state,
                loadingIATAAirlineList: true,
                IATAAirlineList: "",
                IATAAirlineListError: '',
            };
        case 'FIND_IATA_AIRLINE_SUCCESS':
            return {
                ...state,
                loadingIATAAirlineList: false,
                IATAAirlineList: action.payload,
            };
        case 'FIND_IATA_AIRLINE_FAILURE':
            return {
                ...state,
                loadingIATAAirlineList: false,
                IATAAirlineListError: action.payload,
            };
        //list iata airline//

        //list organisation iata //
        case 'FIND_ORGANISATION_IATA_LIST_REQUEST':
            return {
                ...state,
                loadingOrganisationIATAList: true,
                OrganisationIATAList: "",
                OrganisationIATAListError: '',
            };
        case 'FIND_ORGANISATION_IATA_LIST_SUCCESS':
            return {
                ...state,
                loadingOrganisationIATAList: false,
                OrganisationIATAList: action.payload,
            };
        case 'FIND_ORGANISATION_IATA_LIST_FAILURE':
            return {
                ...state,
                loadingOrganisationIATAList: false,
                OrganisationIATAListError: action.payload,
            };
        //list organisation iata //

        //detail organisation iata //
        case 'FIND_ORGANISATION_IATA_DETAIL_REQUEST':
            return {
                ...state,
                loadingOrganisationIATADetail: true,
                OrganisationIATADetail: "",
                OrganisationIATADetailError: '',
            };
        case 'FIND_ORGANISATION_IATA_DETAIL_SUCCESS':
            return {
                ...state,
                loadingOrganisationIATADetail: false,
                OrganisationIATADetail: action.payload,
            };
        case 'FIND_ORGANISATION_IATA_DETAIL_FAILURE':
            return {
                ...state,
                loadingOrganisationIATADetail: false,
                OrganisationIATADetailError: action.payload,
            };
        //detail organisation iata //

        //list organisation reg //
        case 'FIND_ORGANISATION_REG_LIST_REQUEST':
            return {
                ...state,
                loadingOrganisationREGList: true,
                OrganisationREGList: "",
                OrganisationREGListError: '',
            };
        case 'FIND_ORGANISATION_REG_LIST_SUCCESS':
            return {
                ...state,
                loadingOrganisationREGList: false,
                OrganisationREGList: action.payload,
            };
        case 'FIND_ORGANISATION_REG_LIST_FAILURE':
            return {
                ...state,
                loadingOrganisationREGList: false,
                OrganisationREGListError: action.payload,
            };
        //list organisation reg //


        //detail organisation reg //
        case 'FIND_ORGANISATION_REG_DETAIL_REQUEST':
            return {
                ...state,
                loadingOrganisationREGDetail: true,
                OrganisationREGDetail: "",
                OrganisationREGDetailError: '',
            };
        case 'FIND_ORGANISATION_REG_DETAIL_SUCCESS':
            return {
                ...state,
                loadingOrganisationREGDetail: false,
                OrganisationREGDetail: action.payload,
            };
        case 'FIND_ORGANISATION_REG_DETAIL_FAILURE':
            return {
                ...state,
                loadingOrganisationREGDetail: false,
                OrganisationREGDetailError: action.payload,
            };
        //detail organisation reg //

        //detail organisation reg //
        case 'FIND_COMPANY_FINAL_QUOTATION_LIST_REQUEST':
            return {
                ...state,
                loadingCompanyFinalQuotationList: true,
                CompanyFinalQuotationList: [],
                CompanyFinalQuotationCompanyDetails:{},
                CompanyFinalQuotationListError: '',
            };
        case 'FIND_COMPANY_FINAL_QUOTATION_LIST_SUCCESS':
            return {
                ...state,
                loadingCompanyFinalQuotationList: false,
                CompanyFinalQuotationList: action.payload.data,
                CompanyFinalQuotationCompanyDetails: action.payload.customer_data
            };
        case 'FIND_COMPANY_FINAL_QUOTATION_LIST_FAILURE':
            return {
                ...state,
                loadingCompanyFinalQuotationList: false,
                CompanyFinalQuotationListError: action.payload,
            };
        //detail organisation reg //

        //organisation agent list //
        case 'FIND_ORGANISATION_AGENT_REQUEST':
            return {
                ...state,
                loadingOrganisationAgentList: true,
                OrganisationAgentList: [],
                OrganisationAgentListError: '',
            };
        case 'FIND_ORGANISATION_AGENT_SUCCESS':
            return {
                ...state,
                loadingOrganisationAgentList: false,
                OrganisationAgentList: action.payload,
            };
        case 'FIND_ORGANISATION_AGENT_FAILURE':
            return {
                ...state,
                loadingOrganisationAgentList: false,
                OrganisationAgentListError: action.payload,
            };
        //organisation agent list //

        default:
            return state;
    }
}

export default OrganisationListReducer;